import type InboxReminderType from 'owa-service/lib/contract/InboxReminderType';
import type { BookingServiceEmailReminder } from 'owa-graph-schema';
import type EmailReminderChangeType from 'owa-service/lib/contract/EmailReminderChangeType';
import type EmailReminderSendOption from 'owa-service/lib/contract/EmailReminderSendOption';

const mapEmailReminderChangeType = (occurrenceChange: EmailReminderChangeType) => {
    switch (occurrenceChange) {
        case 1:
            return 'Added';
        case 3:
            return 'Deleted';
        case 0:
            return 'None';
        case 2:
            return 'Override';
    }
};

const mapEmailReminderSendOption = (sendOption: EmailReminderSendOption) => {
    switch (sendOption) {
        case 2:
            return 'All';
        case 4:
            return 'Customer';
        case 0:
            return 'NotSet';
        case 3:
            return 'Staff';
        case 1:
            return 'User';
    }
};

const mapInboxReminderType = (
    emailReminders: InboxReminderType[] | undefined
): BookingServiceEmailReminder[] | undefined => {
    if (!emailReminders) {
        return;
    }
    const modifiedEmailReminders: BookingServiceEmailReminder[] =
        emailReminders?.map(
            ({
                Id = '',
                ReminderOffset,
                Message,
                IsOrganizerReminder,
                OccurrenceChange,
                SendOption,
                Subject,
                RichTextMessage,
            }) => ({
                id: Id as string,
                reminderOffset: ReminderOffset?.toString(),
                message: Message as string,
                isOrganizerReminder: IsOrganizerReminder as boolean,
                occurrenceChange: mapEmailReminderChangeType(
                    OccurrenceChange as EmailReminderChangeType
                ),
                sendOption: mapEmailReminderSendOption(SendOption as EmailReminderSendOption),
                subject: Subject as string,
                richTextMessage: RichTextMessage as string,
            })
        ) ?? [];
    return modifiedEmailReminders;
};

export default mapInboxReminderType;
